import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIcon, LazyIconSvg, LazyIconTw } from '#components'
const lazyGlobalComponents = [
  ["Icon", LazyIcon],
["IconSvg", LazyIconSvg],
["IconTw", LazyIconTw],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
